import { z } from "zod";
import { PaymentTypeValues, InvoicesSendingTypeValues } from "@/constants/payments";

export const paymentInfoSchema = z.object({
  depositType: z.nativeEnum(PaymentTypeValues).nullable(),
  depositAccountNumberPrefix: z.string().nullable(),
  depositAccountNumber: z.string().nullable(),
  depositAccountNumberBank: z.string().nullable(),
  overpaidType: z.nativeEnum(PaymentTypeValues).nullable(),
  overpaidAccountNumberPrefix: z.string().nullable(),
  overpaidAccountNumber: z.string().nullable(),
  overpaidAccountNumberBank: z.string().nullable(),
  overpaidAccountNumberIban: z.string().nullable(),
  sendingInvoicesType: z.nativeEnum(InvoicesSendingTypeValues).nullable(),
});

export type PaymentInfo = z.infer<typeof paymentInfoSchema>;
